var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ruleShow seller-style" },
    [
      _c("h2", { staticClass: "f18 fb normal gray_2" }, [_vm._v("规则展示")]),
      _c("div", { staticClass: "box20" }),
      _c("Tinymce", {
        ref: "tinymce",
        attrs: { id: "id", contentInit: _vm.contentInit }
      }),
      _c("div", { staticClass: "box20" }),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c(
            "el-button",
            {
              staticClass: "mar30-r",
              attrs: { type: "primary" },
              on: { click: _vm.saveRule }
            },
            [_vm._v("确 定")]
          ),
          _c("el-button", { on: { click: _vm.cancelRule } }, [_vm._v("取 消")])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }